module.exports = __webpack_public_path__ + "img/Group 3911.7243a33c.png";